/** @module Enums */ /** typedoc */

export enum ProofOfRightsTypeEnum {
    Document = 'Document',
    Url = 'Url',
}

export enum ProofOfRightsContentTypeEnum {
    Samples = 'Samples',
    LicensedInstrumentalOrBeat = 'LicensedInstrumentalOrBeat',
    RemixedContent = 'RemixedContent',
    StockSoundsOrLoops = 'StockSoundsOrLoops',
    Other = 'Other'
}
